import { render, staticRenderFns } from "./ListaUtilizacaoClientes.vue?vue&type=template&id=555bc15f&style=margin%3A0px%3Bpadding%3A0px%3B&"
import script from "./ListaUtilizacaoClientes.vue?vue&type=script&lang=js&"
export * from "./ListaUtilizacaoClientes.vue?vue&type=script&lang=js&"
import style0 from "./ListaUtilizacaoClientes.vue?vue&type=style&index=0&id=555bc15f&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports